import Button from 'monday-ui-react-core/dist/Button';
import React, { useState } from 'react';
import Logo from '../../../assets/getsign-logo.svg';
import EyeIcon from '../../../assets/icons/eye.svg';
import CustomButton from '../../CustomButton';
import { HeaderContainer } from '../Header.styled';
import { default as MondayButton } from 'monday-ui-react-core/dist/Button';
import { useContext } from 'react';
import EditIcon from '../../../assets/icons/edit.svg';
import SaveIcon from '../../../assets/icons/save.svg';
import { FileContext } from '../../../context/FileContext';
import { UpdatedDialog } from '../../index';
import SaveDialogBody from '../../SaveDialogBody/SaveDialogBody';
import FieldErrorDialogBody from '../../FieldErrorDialogBody/FieldErrorDialogBody';
import { useTranslation } from 'react-i18next';
import APP_CONFIG from '../../../config';
import PdfSwitchDropdown from './PdfSwitchDropDown';

const EditorHeader = ({
  isPreview,
  handleEdit,
  isLoading,
  handleSave,
  handlePreview,
  showButtons = true,
  isPreviewLoading,
  isPreviewState,
  isV3 = false,
  fromTemplateGallery = false,
}) => {
  const { t } = useTranslation();
  const [showSavedDialog, setShowSavedDialog] = useState(false);
  const [showFieldErrorDialog, setShowFieldErrorDialog] = useState(false);

  const {
    addedFormFields,
    handleSaveFormFields,
    handleSaveFormFieldsV3,
    handleTemplateFieldsV3,
    validateSaveFormFields,
    triggerToast,
    isEditorSaveLoading,
    setIsEditorSaveLoading,
    isPreviewSaveLoading,
    setIsPreviewSaveLoading,
    isTemplate,
  } = useContext(FileContext);

  const validateFieldsWithNoSigner = () => {
    const fieldsToCheck = [
      APP_CONFIG.form_fields.standard_fields.checkbox.id,
      APP_CONFIG.form_fields.standard_fields.textBox.id,
      APP_CONFIG.form_fields.standard_fields.dropdown.id,
      APP_CONFIG.form_fields.initialsField.id,
      APP_CONFIG.form_fields.signatureField.id,
    ];
    const filteredErrorFields = addedFormFields.filter(
      (x) => fieldsToCheck.includes(x.itemId) && !x.signer,
    );
    return filteredErrorFields.length > 0;
  };

  const handleEditorSave = async () => {
    setIsEditorSaveLoading(true);
    const errorFields = await validateSaveFormFields();
    if (errorFields?.dropdown?.length) {
      triggerToast(
        'Dropdown options required. Select ”Status” column or add options manually.',
      );
      setIsEditorSaveLoading(false);
      return;
    }
    if (errorFields?.link?.length) {
      triggerToast(
        'One or more link added in the pdf do not have a valid url for redirection',
      );
      setIsEditorSaveLoading(false);
      return;
    }
    if (errorFields?.payment?.length) {
      if (!errorFields?.payment?.[0]?.currency)
        triggerToast('Please select currency value in the payment field');
      if (!errorFields?.payment?.[0]?.amountColumn)
        triggerToast(
          'Please select the column for the amount value in the payment field',
        );
      setIsEditorSaveLoading(false);
      return;
    }
    if (errorFields?.textbox?.length) {
      setShowFieldErrorDialog(true);
      setIsEditorSaveLoading(false);
      return;
    }

    const hasFieldsWithNoSigner = validateFieldsWithNoSigner();
    if (hasFieldsWithNoSigner) {
      triggerToast(
        'Some fields added below do not have signer assigned to it.',
      );
      setIsEditorSaveLoading(false);
      return;
    }

    isV3 && fromTemplateGallery
      ? handleTemplateFieldsV3(setShowSavedDialog)
      : isV3 && !fromTemplateGallery
      ? handleSaveFormFieldsV3(setShowSavedDialog)
      : handleSaveFormFields(setShowSavedDialog);
  };

  const handlePreviewSave = async () => {
    setIsPreviewSaveLoading(true);
    const errorFields = await validateSaveFormFields();
    if (errorFields?.dropdown?.length) {
      triggerToast(
        'Dropdown options required. Select ”Status” column or add options manually.',
      );
      setIsPreviewSaveLoading(false);
      return;
    }
    if (errorFields?.link?.length) {
      triggerToast(
        'One or more link added in the pdf do not have a valid url for redirection.',
      );
      setIsPreviewSaveLoading(false);
      return;
    }
    if (errorFields?.textbox?.length) {
      setShowFieldErrorDialog(true);
      setIsPreviewSaveLoading(false);
    } else {
      handleSave();
    }
  };

  return (
    <>
      <HeaderContainer data-name="EditorHeader">
        <img
          src={Logo}
          alt="GetSign Logo"
          width={112}
          height={21.773296356201172}
          style={{ width: 112, height: 21.773296356201172, opacity: 1 }}
        />
        <div className="action-section">
          {showButtons && !isPreview && !isLoading && !isTemplate?.status && (
            <PdfSwitchDropdown t={t} />
          )}
          {showButtons &&
            (isPreview ? (
              <div className="button__group">
                <CustomButton
                  className="hide-in-mobile-view"
                  size={Button.sizes.SMALL}
                  kind={Button.kinds.SECONDARY}
                  icon={EditIcon}
                  key="edit"
                  onClick={handleEdit}
                >
                  {t('Edit')}
                </CustomButton>
                {!isPreviewState ? (
                  <CustomButton
                    className="hide-in-mobile-view"
                    icon={SaveIcon}
                    size={Button.sizes.SMALL}
                    key="save"
                    isLoading={isPreviewSaveLoading}
                    onClick={handlePreviewSave}
                  >
                    {t('Save')}
                  </CustomButton>
                ) : null}
              </div>
            ) : (
              <>
                {!isLoading ? (
                  <div className="button__group">
                    {isPreviewLoading ? (
                      <MondayButton
                        icon={EyeIcon}
                        kind={Button.kinds.SECONDARY}
                        size={Button.sizes.SMALL}
                      >
                        {t('Preview Loading...')}
                      </MondayButton>
                    ) : (
                      <CustomButton
                        className="hide-in-mobile-view"
                        key="preview"
                        icon={EyeIcon}
                        kind={Button.kinds.SECONDARY}
                        size={Button.sizes.SMALL}
                        onClick={handlePreview}
                      >
                        {t('Preview')}
                      </CustomButton>
                    )}
                    <CustomButton
                      className="hide-in-mobile-view"
                      key="save"
                      icon={SaveIcon}
                      size={Button.sizes.SMALL}
                      isLoading={isEditorSaveLoading}
                      onClick={handleEditorSave}
                    >
                      {t('Save')}
                    </CustomButton>
                  </div>
                ) : null}
              </>
            ))}
        </div>
      </HeaderContainer>

      {/* only contents other than buttons from below here */}
      {showSavedDialog ? (
        <UpdatedDialog
          dialogBody={<SaveDialogBody />}
          handleClose={() => {
            setShowSavedDialog(false);
            window.location.reload();
          }}
        />
      ) : null}

      {showFieldErrorDialog ? (
        <UpdatedDialog
          dialogBody={
            <FieldErrorDialogBody
              handleClose={() => setShowFieldErrorDialog(false)}
            />
          }
          handleClose={() => setShowFieldErrorDialog(false)}
        />
      ) : null}
    </>
  );
};

export default EditorHeader;
